export enum PersonalIdEnum {
  PERSONAL_ID ='personalId',
  PASSPORT = 'passport',
  FOREIGN_PASSPORT = 'foreignPassport',
  CITIZENSHIP_CARD = 'citizenshipCard',
  DRIVER_LICENSE = 'driverLicense',
  OTHER = 'otherDocument',
}
